// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/suit-club.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'suit-club',
  version: 'solid',
  paths: [
    {
      d: 'M20.51 13.301a4.357 4.357 0 0 1-8.208 2.053c.06 1.174.264 2.363.808 3.256.546.896 1.52 1.65 2.538 1.904v.495H8.353v-.495c1.018-.256 1.992-1.008 2.538-1.904.544-.893.75-2.082.81-3.256A4.357 4.357 0 0 1 3.49 13.3a4.36 4.36 0 0 1 4.36-4.365h.086a4.363 4.363 0 1 1 8.13 0h.082a4.36 4.36 0 0 1 4.36 4.365',
    },
  ],
}
